import React, { FunctionComponent, useState, useEffect } from 'react';

// INSIDE COMPONENTS
import Dashboard from '../../container/Dashboard/Dashboard'
import BoardAccordion from "../Dashboard/BoardAccordion/BoardAccordion"
import DropdownFilter from "../../components/dropdownFilter/dropdownFilter"
import MainChart from "../../components/charts/MainChart"
import { useTranslation } from 'react-i18next';
import LoadingModal from '../../components/Loadings/LoadingModal';
import FilterPanel from './FilterPanel';
import StickyFilterPanelDashboard from './StickyFilterPanel';
import StickyFilter from './../Module_Wounds/Filters/StickyFilters/StickyFilter';
import "./DashboardPage"
import variables from "../../assets/bootstrap/scss/_variables.scss"

import { colorsGraphs } from "../../utils/constants";

//OUTSIDE COMPONENTS
import { Typography, Checkbox, Paper, LinearProgress, Button, ListItemIcon, ListItem, ListItemText, List } from "@material-ui/core";
import Dropdown from 'react-bootstrap/Dropdown';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { makeStyles } from '@material-ui/core/styles';
import moment, { Moment } from 'moment';
import Image from 'react-bootstrap/Image';

//Images
import FaceOne from '../../utils/painImagesDashboard/face-one';
import FaceTwo from '../../utils/painImagesDashboard/face-two';
import FaceThree from '../../utils/painImagesDashboard/face-three';
import FaceFive from '../../utils/painImagesDashboard/face-five';
import FaceFour from '../../utils/painImagesDashboard/face-four';
import FaceSix from '../../utils/painImagesDashboard/face-six';
import noResults from '../../utils/es-no-results.svg';

//import { ChartData, ChartTooltipItem, ChartDataSets } from 'chart.js';

type OnChangeFnType = (instance: any) => void;
//type OnChangeDatesFnType = (dateFrom: any, dateTo: any) => void;
type OnClearFnType = (type: string) => void;

interface DashboardPageProps {
  isLoading: boolean
  tooltipItem: any
  acessSettings: boolean
  acessWounds: boolean
  spaceUsed: number
  spaceAll: number
  spacePerc: number
  numberOfLicenses: number
  NumberOfPhotos: number,
  NumberOfPacientsMen: number,
  NumberOfPacientsWomen: number,
  NumberOfWounds: number,
  NumberOfWoundsOpen: number,
  NumberOfWoundsClosed: number,
  OnChangeFrom: OnChangeFnType,
  OnChangeTo: OnChangeFnType,
  filterDateFrom: any,
  filterDateTo: any,
  OnClearFilter: OnClearFnType,
  //OnChangeDates: OnChangeDatesFnType,
  NumberOfWoundsAdmission: number,
  NumberOfMonitorDelay: number,
  WoundsByTypeNumbers: any,
  WoundsByTypeLabels: any,
  WoundsByTypePainNumbers: any,
  WoundsByTypePainLabels: any,
  PacientsWoundsOpenByTypeNumbers: any,
  PacientsWoundsOpenByTypeLabels: any,
  WoundsByTypeGenderNumbersMen: any,
  WoundsByTypeGenderNumbersWomen: any,
  WoundsByTypeGenderPercMen: any,
  WoundsByTypeGenderPercWomen: any,
  WoundsByTypeGenderLabels: any,
  WoundsByTypeGenderMin: number,
  WoundsByTypeGenderMax: number,
  WoundsByTypeGenderSteps: number,
  InternmentWoundsLabels: any,
  InternmentWoundsNumbers: any,
  TimeOfStayingMinValues: any,
  TimeOfStayingMaxValues: any,
  TimeOfStayingAvgValues: any,
  TimeOfStayingLabels: any,
  TimeOfStayingMax: number,
  TimeOfStayingMin: number,
  TimeOfStayingSteps: number,
  WoundsByDiagnosisLabels: any,
  WoundsByDiagnosisData: any
  WoundsByDiagnosisMin: number,
  WoundsByDiagnosisMax: number,
  WoundsByDiagnosisSteps: number,
  InterventionsDelayedByTypeLabels: any,
  InterventionsDelayedByTypeNumbers: any,
  WoundsByProductsLabels: any,
  WoundsByProductsData: any
  WoundsByProductsMin: number,
  WoundsByProductsMax: number,
  WoundsByProductsSteps: number,
  establishments: any,
  onChangeEstab: OnChangeFnType,
  selectedEstablishments: any,
  userViewDiskSpace: boolean,
  userViewNumberUsers: boolean,
  userViewUsageLevels: boolean,
  userViewNrWoundsAdmission: boolean,
  userViewAverageWounds: boolean,
  userViewTreatments: boolean,
  userViewUnhealedWounds: boolean,
  userViewWoundsHospitalization: boolean,
  userViewWoundsByType: boolean,
  userViewTreatmentsAfterDate: boolean,
  userViewAveragePain: boolean,
  userViewWoundsTypeDiagnosis: boolean,
  userViewWoundsTypeGender: boolean,
  userViewNrDelayedTreatments: boolean,
  onChangeView: OnClearFnType,
}

const { gridBreakLg, gridBreakMd, gridBreakSm } = variables;

const useStyles = makeStyles((theme: { palette: { text: { primary: any; }; }; }) => ({
  root: {
    '&.MuiCheckbox-root': {
      paddingLeft: 0,
    },
    '&.MuiList-root': {
      marginTop: 7,
      width: 80,
    },
    '&.MuiListItemIcon-root': {
      minWidth: 29,
      maxWidth: 30,

      display: "inline",
      textAlign: "center"
    },
    '&.MuiListItem-root': {
      paddingTop: 5,
      paddingBottom: 0,
      paddingLeft: 4,
      paddingRight: 4,
    },
    '&.MuiListItemText-root': {
      whiteSpace: "nowrap",

    },
    '&.MuiCheckbox-colorSecondary': {
      '&.Mui-checked': {
        color: "#4CB3BA",
      }
    }
  },
  ListItem: {
    fontSize: 10,
    padding: 0,
  },
  h1: {
    fontSize: 90,
  },
  h2: {
    fontWeight: 300,
  },
  h4: {
    fontWeight: 500,
  },
  h5: {
    fontFamily: "Nunito",
    fontWeight: 700,
    letterSpacing: 1,
    fontSize: 16
  },
  h6: {
    fontSize: 17,
  },
  body1: {
    color: theme.palette.text.primary,
  },
  body2: {
    color: theme.palette.text.primary,
  },
  subtitle2: {
    fontSize: 12,
    color: theme.palette.text.primary,
  },
  dateLabels: {
    width: 70,
  },
  titleDoghnut: {
    height: 65,
  },
}));

const DashboardPage: FunctionComponent<DashboardPageProps> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();

  //states
  const [width, setWidth] = useState(0);

  const updateWindowDimensions = () => {
    setWidth(window.innerWidth)
  }


  useEffect(() => {
    updateWindowDimensions()
    /* Close modal filter when the viewport is on MD */
    /*         if (width >= parseInt(gridBreakMd)) {
                setIsFilterDateModalOpen(false);
            } */
  });


  return (
    <>
      <Dashboard>
        <StickyFilter containerClasses="top-0 sticky-container-top-fixed">
          <StickyFilterPanelDashboard
            OnChangeFrom={props.OnChangeFrom}
            OnChangeTo={props.OnChangeTo}
            filterDateFrom={props.filterDateFrom}
            filterDateTo={props.filterDateTo}
            OnClearFilter={props.OnClearFilter}
            establishments={props.establishments}
            onChangeEstab={props.onChangeEstab}
            selectedEstablishments={props.selectedEstablishments}
          ></StickyFilterPanelDashboard>
        </StickyFilter>
        <Container>
          <FilterPanel
            OnChangeFrom={props.OnChangeFrom}
            OnChangeTo={props.OnChangeTo}
            filterDateFrom={props.filterDateFrom}
            filterDateTo={props.filterDateTo}
            OnClearFilter={(type) => props.OnClearFilter(type)}
            establishments={props.establishments}
            onChangeEstab={props.onChangeEstab}
            selectedEstablishments={props.selectedEstablishments}
          ></FilterPanel>
          <BoardAccordion
            title={t('Dashboard.GlobalVision')}
            hidden={!props.acessSettings}
            /* filterMobileButton={(e: any) => {
                toogleFilterDateModal();
                e.preventDefault();
                e.stopPropagation();
            }} */

            filterMore={
              <>
                <DropdownFilter
                  items={
                    <>
                      <Typography variant="body2" noWrap={true} className="px-4" onClick={() => props.onChangeView("userViewAllGlobal")}>
                        <Checkbox
                          checked={props.userViewDiskSpace && props.userViewNumberUsers && props.userViewUsageLevels} className={`${classes.root}`} disableRipple size="small"></Checkbox>
                        {t('SeeAll')}</Typography>
                      <Dropdown.Divider />

                      <Typography variant="body2" noWrap={true} className="px-4" onClick={() => props.onChangeView("userViewDiskSpace")}>
                        <Checkbox checked={props.userViewDiskSpace} className={`${classes.root}`} disableRipple size="small"></Checkbox>
                        {t('diskSpace')}</Typography>

                      <Typography variant="body2" noWrap={true} className="px-4" onClick={() => props.onChangeView("userViewNumberUsers")}>
                        <Checkbox checked={props.userViewNumberUsers} className={`${classes.root}`} disableRipple size="small"></Checkbox>
                        {t('Dashboard.NumberOfUsers')}</Typography>

                      <Typography variant="body2" noWrap={true} className="px-4" onClick={() => props.onChangeView("userViewUsageLevels")}>
                        <Checkbox checked={props.userViewUsageLevels} className={`${classes.root}`} disableRipple size="small"></Checkbox>
                        {t('Dashboard.LevelsOfUsing')}</Typography>
                    </>
                  }
                ></DropdownFilter>
              </>
            }
          >
             {!props.userViewDiskSpace && !props.userViewNumberUsers && !props.userViewUsageLevels ?
                  
                  <div className="empty-state-container text-center my-5 py-5" hidden={props.isLoading}>
                    <Image className={`empty-state-graph pt-4`} fluid alt="empty state" src={noResults}></Image>
                    <Typography variant='subtitle2' className={`pb-3 ${classes.h6}`}>
                      {t('EmptyStates.ActiveIndicators')} 
                    </Typography>
                  </div>
                : 
                ""
              }

            <Row>
              <Col lg={3} md={6} xs={12} className="card-global-vision" hidden={!props.userViewDiskSpace}>
                <Paper className="position-relative card-user card-topic card-global-vision my-3 my-md-4">
                  <Typography variant='h6' className={`pb-4 ${classes.h6}`}>
                    {t('diskSpace')}
                  </Typography>
                  <LoadingModal hidden={!props.isLoading} />
                  <div hidden={props.isLoading}>
                    <Typography variant='body1' color="primary" className="linear-progress-space-occupy" >
                      {props.spaceUsed}
                    </Typography>
                    <div className="d-flex">
                      <LinearProgress
                        className='w-100 my-auto dashboard-linear-progress'
                        variant={'determinate'}
                        value={props.spacePerc}
                      />
                      <Typography variant='body1' className={`pl-5 roboto-black ${classes.body1} min-width-space`}>
                        {props.spaceAll}
                      </Typography>
                    </div>
                    <Typography variant="body2" className="pt-2" color="primary">{t('Dashboard.UsedSpace')} <span className="font-black pl-3">{props.spaceUsed}</span></Typography>
                    <Typography variant="body2" className="pt-1">{t('Dashboard.TotalSpace')} <span className="font-black pl-3">{props.spaceAll}</span></Typography>
                    <Button
                      className="px-4 py-0 font-size-12-px button-report-apply my-auto text-capitalize dashboard-buy-button"
                      color="primary"
                      variant="contained"
                      disableRipple
                      disableTouchRipple
                      disableElevation
                      focusRipple
                      href={t('Dashboard.BuyMoreURL')}
                      target="_blank"
                    >{t('BuyMore')}
                    </Button>
                  </div>
                </Paper>
              </Col>
              <Col lg={3} md={6} xs={12} className="card-global-vision" hidden={!props.userViewNumberUsers}>
                <Paper className="position-relative card-user card-topic my-3 my-md-4">
                  <Typography variant='h6' className={classes.h6}>
                    {t('Dashboard.NumberOfUsers')}
                  </Typography>
                  <LoadingModal hidden={!props.isLoading} />
                  <Typography variant='h2' className={`${classes.h2} pt-4 mt-5 text-center`} hidden={props.isLoading}>
                    {props.numberOfLicenses}
                  </Typography>
                  <Button
                    className="px-4 py-0 font-size-12-px button-report-apply my-auto text-capitalize dashboard-buy-button"
                    color="primary"
                    variant="contained"
                    disableRipple
                    disableTouchRipple
                    disableElevation
                    focusRipple
                    href={t('Dashboard.BuyMoreUsersURL')}
                    target="_blank"
                    hidden={props.isLoading}
                  >
                    {t('BuyMore')}
                  </Button>
                </Paper>
              </Col>
              <Col lg={6} xs={12} className="card-global-vision" hidden={!props.userViewUsageLevels}>
                <Paper className={`${width >= 768 ? "card-user" : "card-user h-97"} card-topic my-3 my-md-2 my-lg-4`}>
                  <Typography variant='h6' className={`${width >= 768} ? "" : ${` pb-4 ${classes.h6} `} `}>
                    {t('Dashboard.LevelsOfUsing')}
                  </Typography>
                  <LoadingModal hidden={!props.isLoading} />
                  {width >= 768 ?
                    <table className="w-100 mt-5 pt-4" hidden={props.isLoading}>
                      <tr className="text-center vertical-align-top">
                        <th className="font-size-10-px text-uppercase roboto-regular width-levels-using-parameters">{t('Dashboard.NumberPhotos')}</th>
                        <th className="font-size-10-px text-uppercase roboto-regular width-levels-using-parameters">{t('Dashboard.NumberOfRegistedWounds')}</th>
                        <th className="font-size-10-px text-uppercase roboto-regular width-levels-using-parameters">{t('Dashboard.ToHealing')}</th>
                        <th className="font-size-10-px text-uppercase roboto-regular width-levels-using-parameters">{t('Dashboard.Healed')}</th>
                        <th className="font-size-10-px text-uppercase roboto-regular width-levels-using-parameters">{t('Dashboard.ActivePatients')}</th>
                      </tr>
                      <tr className="text-center pt-3">
                        <td><Typography variant="h4" className={classes.h4}>{props.NumberOfPhotos}</Typography></td>
                        <td><Typography variant="h4" className={classes.h4}>{props.NumberOfWounds}</Typography></td>
                        <td><Typography variant="h4" className={classes.h4}>{props.NumberOfWoundsOpen}</Typography></td>
                        <td><Typography variant="h4" className={classes.h4}>{props.NumberOfWoundsClosed}</Typography></td>
                        <td className="text-center-td">
                          <tr>
                            <td className="h-100 px-2"><Typography className="text-left font-size-12-px roboto-regular">{t('Dashboard.Men')} </Typography></td>
                            <td className="px-2 font-size-10-px roboto-regular font-bold font-size-20-px">{props.NumberOfPacientsMen}</td>
                          </tr>
                          <tr className="text-left">
                            <td className="px-2 h-100"><Typography className="text-left font-size-12-px roboto-regular">{t('Dashboard.Women')}</Typography></td>
                            <td className="px-2 font-size-10-px roboto-regular font-bold font-size-20-px">{props.NumberOfPacientsWomen}</td>
                          </tr>
                        </td>
                      </tr>
                    </table>
                    :
                    <div hidden={props.isLoading}>
                      <div className="text-center pt-5">
                        <div className={`font-size-10-px text-uppercase roboto-regular pb-4`}>{t('Dashboard.NumberPhotos')}</div>
                        <Typography variant="h4" className={`${classes.h4} pb-4`}>{props.NumberOfPhotos}</Typography>
                      </div>
                      <div className="text-center pt-5">
                        <div className={`font-size-10-px text-uppercase roboto-regular pb-4`}>{t('Dashboard.NumberOfRegistedWounds')}</div>
                        <Typography variant="h4" className={`${classes.h4} pb-4`}>{props.NumberOfWounds}</Typography>
                      </div>
                      <div className="text-center pt-5">
                        <div className="font-size-10-px text-uppercase roboto-regular pb-4">{t('Dashboard.ToHealing')}</div>
                        <Typography variant="h4" className={`${classes.h4} pb-4`}>{props.NumberOfWoundsOpen}</Typography>
                      </div>
                      <div className="text-center pt-5">
                        <div className="font-size-10-px text-uppercase roboto-regular pb-4">{t('Dashboard.Healed')}</div>
                        <Typography variant="h4" className={`${classes.h4} pb-4`}>{props.NumberOfWoundsClosed}</Typography>
                      </div>
                      <div className="text-center pt-5">
                        <div className="font-size-10-px text-uppercase roboto-regular pb-4">{t('Dashboard.ActivePatients')}</div>
                        <table className="w-100">
                          <tr className="text-center">
                            <td className="text-center-td">
                              <tr>
                                <td className="h-100 px-2"><Typography className="text-left font-size-12-px roboto-regular">{t('Dashboard.Men')} </Typography></td>
                                <td className="px-2 font-size-10-px roboto-regular font-bold font-size-20-px">{props.NumberOfPacientsMen}</td>
                              </tr>
                              <tr className="text-left">
                                <td className="px-2 h-100"><Typography className="text-left font-size-12-px roboto-regular">{t('Dashboard.Women')}</Typography></td>
                                <td className="px-2 font-size-10-px roboto-regular font-bold font-size-20-px">{props.NumberOfPacientsWomen}</td>
                              </tr>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  }
                </Paper>
              </Col>
            </Row>
          </BoardAccordion>

          <BoardAccordion
            title={t('Dashboard.ClinicVision')}
            hidden={!props.acessWounds}
            /*  filterMobileButton={(e: any) => {
                 toogleFilterDateModal();
                 e.preventDefault();
                 e.stopPropagation();
             }
             } */
            filterMore={
              <>
                <DropdownFilter
                  items={
                    <>
                      <Typography variant="body2" noWrap={width >= parseInt(gridBreakMd) ? true : false} className="px-4" onClick={() => props.onChangeView("userViewAllClinical")}>
                        <Checkbox
                          checked={props.userViewNrWoundsAdmission && props.userViewAverageWounds && props.userViewTreatments && props.userViewUnhealedWounds && props.userViewWoundsHospitalization && props.userViewWoundsByType && props.userViewTreatmentsAfterDate && props.userViewAveragePain && props.userViewWoundsTypeDiagnosis && props.userViewWoundsTypeGender && props.userViewNrDelayedTreatments}
                          className={`${classes.root}`} disableRipple size="small"></Checkbox>
                        {t('SeeAll')}</Typography>
                      <Dropdown.Divider />
                      <Typography variant="body2" noWrap={width >= parseInt(gridBreakMd) ? true : false} className="px-4" onClick={() => props.onChangeView("userViewNrWoundsAdmission")}><Checkbox checked={props.userViewNrWoundsAdmission} className={`${classes.root}`} disableRipple size="small" ></Checkbox>{t('Dashboard.NumberPatientsWithWoundOnAdmission')}</Typography>
                      <Typography variant="body2" noWrap={width >= parseInt(gridBreakMd) ? true : false} className="px-4" onClick={() => props.onChangeView("userViewAverageWounds")}><Checkbox checked={props.userViewAverageWounds} className={`${classes.root}`} disableRipple size="small" ></Checkbox>{t('Dashboard.AverageTimeOfStayingMaxMin')}</Typography>
                      <Typography variant="body2" noWrap={width >= parseInt(gridBreakMd) ? true : false} className="px-4" onClick={() => props.onChangeView("userViewTreatments")}><Checkbox checked={props.userViewTreatments} className={`${classes.root}`} disableRipple size="small" ></Checkbox>{t('Dashboard.TreatmentsUsed')}</Typography>
                      <Typography variant="body2" noWrap={width >= parseInt(gridBreakMd) ? true : false} className="px-4" onClick={() => props.onChangeView("userViewUnhealedWounds")}><Checkbox checked={props.userViewUnhealedWounds} className={`${classes.root}`} disableRipple size="small" ></Checkbox>{t('Dashboard.NumberPatientsDischargedWithUnhealedWounds')}</Typography>
                      <Typography variant="body2" noWrap={width >= parseInt(gridBreakMd) ? true : false} className="px-4" onClick={() => props.onChangeView("userViewWoundsHospitalization")}><Checkbox checked={props.userViewWoundsHospitalization} className={`${classes.root}`} disableRipple size="small" ></Checkbox>{t('Dashboard.PercentageOfWoundsGenerated')}</Typography>
                      <Typography variant="body2" noWrap={width >= parseInt(gridBreakMd) ? true : false} className="px-4" onClick={() => props.onChangeView("userViewWoundsByType")}><Checkbox checked={props.userViewWoundsByType} className={`${classes.root}`} disableRipple size="small" ></Checkbox>{t('Dashboard.PercentageOfWoundsByType')}</Typography>
                      <Typography variant="body2" noWrap={width >= parseInt(gridBreakMd) ? true : false} className="px-4" onClick={() => props.onChangeView("userViewTreatmentsAfterDate")}><Checkbox checked={props.userViewTreatmentsAfterDate} className={`${classes.root}`} disableRipple size="small" ></Checkbox>{t('Dashboard.PercentageOfTreatmentsCarriedOutAfterExpectedDate')}</Typography>
                      <Typography variant="body2" noWrap={width >= parseInt(gridBreakMd) ? true : false} className="px-4" onClick={() => props.onChangeView("userViewAveragePain")}><Checkbox checked={props.userViewAveragePain} className={`${classes.root}`} disableRipple size="small" ></Checkbox>{t('Dashboard.AveragePainByTypeOfWound')}</Typography>
                      <Typography variant="body2" noWrap={width >= parseInt(gridBreakMd) ? true : false} className="px-4" onClick={() => props.onChangeView("userViewWoundsTypeDiagnosis")}><Checkbox checked={props.userViewWoundsTypeDiagnosis} className={`${classes.root}`} disableRipple size="small" ></Checkbox>{t('Dashboard.WoundTypesNumberPercentageByDiagnoses')}</Typography>
                      <Typography variant="body2" noWrap={width >= parseInt(gridBreakMd) ? true : false} className="px-4" onClick={() => props.onChangeView("userViewWoundsTypeGender")}><Checkbox checked={props.userViewWoundsTypeGender} className={`${classes.root}`} disableRipple size="small" ></Checkbox>{t('Dashboard.TypesOfWoundsNumberPercentageByGender')}</Typography>
                      <Typography variant="body2" noWrap={width >= parseInt(gridBreakMd) ? true : false} className="px-4" onClick={() => props.onChangeView("userViewNrDelayedTreatments")}><Checkbox checked={props.userViewNrDelayedTreatments} className={`${classes.root}`} disableRipple size="small" ></Checkbox>{t('Dashboard.NumberOfDelayedTreatments')}</Typography>
                    </>
                  }></DropdownFilter>
              </>
            }
          /* onChangeFrom={onChangeFromData}
          onChangeTo={onChangeToData}
          filterDateFrom={props.filterDateFrom}
          filterDateTo={props.filterDateTo} */
          >
            {!props.userViewNrWoundsAdmission && !props.userViewAverageWounds && !props.userViewTreatments && !props.userViewUnhealedWounds && !props.userViewWoundsHospitalization && !props.userViewWoundsByType && !props.userViewTreatmentsAfterDate && !props.userViewAveragePain && !props.userViewWoundsTypeDiagnosis && !props.userViewWoundsTypeGender && !props.userViewNrDelayedTreatments ?
               <div className="empty-state-container text-center my-5 py-5" hidden={props.isLoading}>
               <Image className={`empty-state-graph pt-4`} fluid alt="empty state" src={noResults}></Image>
               <Typography variant='subtitle2' className={`pb-3 ${classes.h6}`}>
                  {t('EmptyStates.ActiveIndicators')} 
               </Typography>
             </div>
              : 
              ""
            }
            <Row className="mb-5 pb-4 mb-md-4 pb-md-4 mb-lg-4 pb-lg-4">
              <Col lg={3} xs={12} hidden={!props.userViewNrWoundsAdmission}>
                <Paper className="card-user-clinical-vison only-numbers my-3 my-md-3 my-lg-4">
                  <Typography variant='h6' className={classes.h6}>
                    {t('Dashboard.NumberPatientsWithWoundOnAdmission')}
                  </Typography>
                  <Typography variant='h1' className={`${classes.h1} pt-5 mt-5 text-center`} hidden={props.isLoading}>
                    {props.NumberOfWoundsAdmission}
                  </Typography>
                  <LoadingModal hidden={!props.isLoading} />
                </Paper>
              </Col>
              <Col lg={9} xs={12} hidden={!props.userViewAverageWounds}>
                <Paper className="card-user-clinical-vison my-3 my-md-3 my-lg-4">
                  <Typography variant='h6' className={`pb-3 ${classes.h6}`}>
                    {t('Dashboard.AverageTimeOfStayingMaxMin')}
                  </Typography>
                  <div className="text-center px-0 px-md-5 px-lg-0">
                    <div className="empty-state-container position-absolute left-0 right-0" hidden={props.TimeOfStayingLabels.length > 0 || props.isLoading}>
                      <Image className={`empty-state-graph pt-4`} fluid alt="empty state" src={noResults}></Image>
                      <Typography variant='subtitle2' className={`pb-3 ${classes.h6}`}>
                        {t('EmptyStates.NoResults')}
                      </Typography>
                    </div>
                    <LoadingModal hidden={!props.isLoading} />
                    <MainChart
                      hidden={props.isLoading || props.TimeOfStayingLabels.length == 0}
                      typeOfChart='bar'
                      chartLabels={props.TimeOfStayingLabels}
                      data={[{
                        backgroundColor: '#7E57C2',
                        borderColor: '#7E57C2',
                        borderWidth: 1,
                        data: props.TimeOfStayingMinValues,
                        hidden: false,
                        label: t('Dashboard.TimeMin'),
                        fontSize: 27
                      },
                      {
                        backgroundColor: '#26A69A',
                        borderColor: '#26A69A',
                        borderWidth: 1,
                        data: props.TimeOfStayingAvgValues,
                        hidden: false,
                        label: t('Dashboard.TimeAvg'),
                        fontSize: 27
                      }, {
                        backgroundColor: '#FFA726',
                        borderColor: '#FFA726',
                        borderWidth: 1,
                        data: props.TimeOfStayingMaxValues,
                        hidden: false,
                        label: t('Dashboard.TimeMax'),
                        fontSize: 27
                      }
                      ]}
                      yAxesTicksMin={props.TimeOfStayingMin}
                      yAxesTicksMax={props.TimeOfStayingMax}
                      yAxesStepSize={props.TimeOfStayingSteps}
                      tooltipCallback={{}}
                      yAxesTicksCallback={(value, position, array) => {

                        if (position === 0) {
                          return value = '';
                        }
                        return value
                      }}

                    >
                    </MainChart>
                  </div>
                </Paper>
              </Col>
              <Col lg={12} xs={12} hidden={!props.userViewTreatments}>
                <Paper className="card-user-clinical-vison my-3 my-md-3 my-lg-4">
                  <Typography variant='h6' className={`pb-3 ${classes.h6}`}>
                    {t('Dashboard.TreatmentsUsed')}
                  </Typography>
                  <div className="text-center px-0 px-md-5 px-lg-0">
                    <div className="empty-state-container position-absolute left-0 right-0" hidden={props.WoundsByProductsLabels.length > 0 || props.isLoading}>
                      <Image className={`empty-state-graph pt-4`} fluid alt="empty state" src={noResults}></Image>
                      <Typography variant='subtitle2' className={`pb-3 ${classes.h6}`}>
                        {t('EmptyStates.NoResults')}
                      </Typography>
                    </div>
                    <LoadingModal hidden={!props.isLoading} />
                    <MainChart
                      typeOfChart='bar'
                      hidden={props.isLoading || props.WoundsByProductsLabels.length == 0}
                      chartLabels={props.WoundsByProductsLabels}
                      data={props.WoundsByProductsData}
                      yAxesTicksMin={props.WoundsByProductsMin}
                      yAxesTicksMax={props.WoundsByProductsMax}
                      yAxesStepSize={props.WoundsByProductsSteps}
                      tooltipCallback={{}}
                      yAxesTicksCallback={(value, position, array) => {
                        if (position === 0) {
                          return value = '';
                        }
                        return value
                      }}
                      xStacked={true}
                      yStacked={true}
                    >
                    </MainChart>
                  </div>
                </Paper>
              </Col>
              <Col lg={6} xs={12} className="chart-doughnut" hidden={!props.userViewUnhealedWounds}>
                <Paper className="card-user-clinical-vison my-3 my-md-3 my-lg-4">
                  <Typography variant='h6' className={`${classes.titleDoghnut} ${classes.h6}`}>
                    {t('Dashboard.NumberPatientsDischargedWithUnhealedWounds')}
                  </Typography>
                  <div className="text-center px-0 px-md-5 px-lg-0">
                    <div className="empty-state-container position-absolute left-0 right-0" hidden={props.PacientsWoundsOpenByTypeLabels.length > 0 || props.isLoading}>
                      <Image className={`empty-state-graph pt-4`} fluid alt="empty state" src={noResults}></Image>
                      <Typography variant='subtitle2' className={`pb-3 ${classes.h6}`}>
                        {t('EmptyStates.NoResults')}
                      </Typography>
                    </div>
                    <LoadingModal hidden={!props.isLoading} />
                    <MainChart
                      hidden={props.isLoading || props.PacientsWoundsOpenByTypeLabels.length == 0}
                      typeOfChart='doughnut'
                      chartLabels={props.PacientsWoundsOpenByTypeLabels}
                      firstBackgroundColorData={colorsGraphs}
                      firstBorderColorData={colorsGraphs}
                      firstData={props.PacientsWoundsOpenByTypeNumbers}
                      tooltipCallback={{
                        label: function (tooltipItem: any, data: any): string | string[] {

                          let dataset = (data.datasets || '')[tooltipItem.datasetIndex];

                          let currentValue = dataset.data[tooltipItem.index] as number;

                          return props.PacientsWoundsOpenByTypeLabels[tooltipItem.index] + ": " + currentValue;
                        }
                      }}
                    >
                    </MainChart>
                  </div>
                </Paper>
              </Col>
              <Col lg={6} xs={12} className="chart-doughnut" hidden={!props.userViewWoundsHospitalization}>
                <Paper className="card-user-clinical-vison my-3 my-md-3 my-lg-4">
                  <Typography variant='h6' className={`${classes.titleDoghnut} ${classes.h6}`}>
                    {t('Dashboard.PercentageOfWoundsGenerated')}
                  </Typography>
                  <div className="text-center px-0 px-md-5 px-lg-0">
                    <div className="empty-state-container position-absolute left-0 right-0" hidden={props.InternmentWoundsLabels.length > 0 || props.isLoading}>
                      <Image className={`empty-state-graph pt-4`} fluid alt="empty state" src={noResults}></Image>
                      <Typography variant='subtitle2' className={`pb-3 ${classes.h6}`}>
                        {t('EmptyStates.NoResults')}
                      </Typography>
                    </div>
                    <LoadingModal hidden={!props.isLoading} />
                    <MainChart
                      hidden={props.isLoading || props.InternmentWoundsLabels.length == 0}
                      typeOfChart='doughnut'
                      chartLabels={props.InternmentWoundsLabels}
                      firstBackgroundColorData={colorsGraphs}
                      firstBorderColorData={colorsGraphs}
                      firstData={props.InternmentWoundsNumbers}
                      // customTooltip={customTooltip}
                      // tooltipCallback={tooltipCallback}
                      tooltipCallback={{
                        label: function (tooltipItem: any, data: any): string | string[] {

                          let dataset = (data.datasets || '')[tooltipItem.datasetIndex];
                          let total: number = (dataset.data || '').reduce(function (previousValue: number, currentValue: number) {
                            return previousValue + currentValue;
                          });
                          let currentValue = dataset.data[tooltipItem.index] as number;
                          let precentage = Math.floor(((currentValue / total) * 100) + 0.5);
                          //return props.InternmentWoundsLabels[tooltipItem.index] + ": " + precentage + "% (" + currentValue + " " + t('of') + " " + total + ")";
                          return props.InternmentWoundsLabels[tooltipItem.index] + ": " + precentage + " %";
                        },
                        afterLabel: function (tooltipItem: any, data: any): string | string[] {
                          let dataset = (data.datasets || '')[tooltipItem.datasetIndex];
                          let total: number = (dataset.data || '').reduce(function (previousValue: number, currentValue: number) {
                            return previousValue + currentValue;
                          });
                          let currentValue = dataset.data[tooltipItem.index] as number;
                          //let precentage = Math.floor(((currentValue / total) * 100) + 0.5);
                          return t('navBar.wounds') + ": " + currentValue + " " + t('of') + " " + total;
                        }
                      }}>
                    </MainChart>
                  </div>
                </Paper>
              </Col>
              <Col lg={6} xs={12} className="chart-doughnut" hidden={!props.userViewWoundsByType}>
                <Paper className="card-user-clinical-vison my-3 my-md-3 my-lg-4">
                  <Typography variant='h6' className={`${classes.titleDoghnut} ${classes.h6}`}>
                    {t('Dashboard.PercentageOfWoundsByType')}
                  </Typography>
                  <div className="text-center px-0 px-md-5 px-lg-0">
                    <LoadingModal hidden={!props.isLoading} />
                    <div className="empty-state-container position-absolute left-0 right-0" hidden={props.WoundsByTypeLabels.length > 0 || props.isLoading}>
                      <Image className={`empty-state-graph pt-4`} fluid alt="empty state" src={noResults}></Image>
                      <Typography variant='subtitle2' className={`pb-3 ${classes.h6}`}>
                        {t('EmptyStates.NoResults')}
                      </Typography>
                    </div>
                    <MainChart
                      hidden={props.isLoading || props.WoundsByTypeLabels.length == 0}
                      typeOfChart='doughnut'
                      chartLabels={props.WoundsByTypeLabels}
                      firstBackgroundColorData={colorsGraphs}
                      firstBorderColorData={colorsGraphs}
                      firstData={props.WoundsByTypeNumbers}
                      tooltipCallback={{
                        label: function (tooltipItem: any, data: any): string | string[] {
                          let dataset = (data.datasets || '')[tooltipItem.datasetIndex];
                          let total: number = (dataset.data || '').reduce(function (previousValue: number, currentValue: number) {
                            return previousValue + currentValue;
                          });
                          let currentValue = dataset.data[tooltipItem.index] as number;
                          let precentage = Math.floor(((currentValue / total) * 100) + 0.5);
                          //return props.WoundsByTypeLabels[tooltipItem.index] + ": " + precentage + "% (" + currentValue + " " + t('of') + " " + total + ")";
                          return props.WoundsByTypeLabels[tooltipItem.index] + ": " + precentage + " %";
                        },
                        afterLabel: function (tooltipItem: any, data: any): string | string[] {
                          let dataset = (data.datasets || '')[tooltipItem.datasetIndex];
                          let total: number = (dataset.data || '').reduce(function (previousValue: number, currentValue: number) {
                            return previousValue + currentValue;
                          });
                          let currentValue = dataset.data[tooltipItem.index] as number;
                          let precentage = Math.floor(((currentValue / total) * 100) + 0.5);
                          return t('navBar.wounds') + ": " + currentValue + " " + t('of') + " " + total;
                        }
                      }}
                    >
                    </MainChart>
                  </div>
                </Paper>
              </Col>
              <Col lg={6} xs={12} className="chart-doughnut" hidden={!props.userViewTreatmentsAfterDate}>
                <Paper className="card-user-clinical-vison my-3 my-md-3 my-lg-4">
                  <Typography variant='h6' className={`${classes.titleDoghnut} ${classes.h6}`}>
                    {t('Dashboard.PercentageOfTreatmentsCarriedOutAfterExpectedDate')}
                  </Typography>
                  <div className="text-center px-0 px-md-5 px-lg-0" >
                    <div className="empty-state-container position-absolute left-0 right-0" hidden={props.InterventionsDelayedByTypeLabels.length > 0 || props.isLoading}>
                      <Image className={`empty-state-graph pt-4`} fluid alt="empty state" src={noResults}></Image>
                      <Typography variant='subtitle2' className={`pb-3 ${classes.h6}`}>
                        {t('EmptyStates.NoResults')}
                      </Typography>
                    </div>
                    <LoadingModal hidden={!props.isLoading} />
                    <MainChart
                      hidden={props.isLoading || props.InterventionsDelayedByTypeLabels.length == 0}
                      typeOfChart='doughnut'
                      chartLabels={props.InterventionsDelayedByTypeLabels}
                      firstBackgroundColorData={colorsGraphs}
                      firstBorderColorData={colorsGraphs}
                      firstData={props.InterventionsDelayedByTypeNumbers}
                      tooltipCallback={{
                        title: function (tooltipItem: any, data: any): string | string[] {
                          return props.InterventionsDelayedByTypeLabels[tooltipItem[0].index];

                          //return props.InterventionsDelayedByTypeLabels[tooltipItem.index];
                        },
                        label: function (tooltipItem: any, data: any): string | string[] {
                          let dataset = (data.datasets || '')[tooltipItem.datasetIndex];
                          let total: number = (dataset.data || '').reduce(function (previousValue: number, currentValue: number) {
                            return previousValue + currentValue;
                          });
                          let currentValue = dataset.data[tooltipItem.index] as number;
                          let precentage = Math.floor(((currentValue / total) * 100) + 0.5);
                          //return props.InterventionsDelayedByTypeLabels[tooltipItem.index] + ": " + precentage + "% (" + currentValue + " " + t('of') + " " + total + ")";
                          return props.InterventionsDelayedByTypeLabels[tooltipItem.index] + ": " + precentage + " %";
                        },
                        afterLabel: function (tooltipItem: any, data: any): string | string[] {
                          let dataset = (data.datasets || '')[tooltipItem.datasetIndex];
                          let total: number = (dataset.data || '').reduce(function (previousValue: number, currentValue: number) {
                            return previousValue + currentValue;
                          });
                          let currentValue = dataset.data[tooltipItem.index] as number;
                          //let precentage = Math.floor(((currentValue / total) * 100) + 0.5);
                          return t('navBar.wounds') + ": " + currentValue + " " + t('of') + " " + total;
                        }
                      }}
                    >
                    </MainChart>
                  </div>
                </Paper>
              </Col>
              <Col lg={6} xs={12} hidden={!props.userViewAveragePain}>
                <Paper className="card-user-clinical-vison my-3 my-md-3 my-lg-4">
                  <Typography variant='h6' className={`pb-3 ${classes.h6}`}>
                    {t('Dashboard.AveragePainByTypeOfWound')}
                  </Typography>
                  <div className="text-center px-0 px-md-5 px-lg-0" >
                    <div className="empty-state-container position-absolute left-0 right-0" hidden={props.WoundsByTypePainLabels.length > 0 || props.isLoading}>
                      <Image className={`empty-state-graph pt-4`} fluid alt="empty state" src={noResults}></Image>
                      <Typography variant='subtitle2' className={`pb-3 ${classes.h6}`}>
                        {t('EmptyStates.NoResults')}
                      </Typography>
                    </div>
                    <LoadingModal hidden={!props.isLoading} />
                    <div className="d-md-flex px-md-5 px-lg-0" hidden={props.isLoading || props.WoundsByTypePainLabels.length == 0}>

                      <MainChart
                        hidden={props.isLoading || props.WoundsByTypePainLabels.length == 0}
                        typeOfChart="line"
                        chartClasses="w-100"
                        labelsXAxis={props.WoundsByTypePainLabels}
                        firstBorderColorData={"#5B6AC1"}
                        firstBackgroundColorData={"#5B6AC1"}
                        firstData={props.WoundsByTypePainNumbers}
                        dateFrom={props.filterDateFrom}
                        dateTo={props.filterDateTo}
                        legendDisplay={false}
                        yAxesTicksMin={0}
                        yAxesTicksMax={11}
                        yAxesStepSize={1}
                        customTooltip={function (tooltip) {
                          // disable displaying the color box;
                          tooltip.displayColors = false;
                        }}
                        tooltipCallback={
                          {
                            title: function () {
                              return ""
                            },
                            label: function (tooltipItem, data) {
                              let label: string | number | string[] | Date | Moment | number[] | Date[] | Moment[] = props.WoundsByTypePainLabels[tooltipItem.index as any];
                              return label + ': ' + tooltipItem.yLabel;
                            },
                            labelColor: function (tooltipItem: any, chart: any) {
                              return {
                                borderColor: null,
                                backgroundColor: null
                              };
                            } as any,
                          }
                        }
                        yAxesTicksCallback={(value, position, array) => {
                          if (position === 0) {
                            return value = '';
                          }
                          return value
                        }}
                      >
                      </MainChart>

                      <div hidden={props.isLoading || props.WoundsByTypePainLabels.length == 0}>

                        <List className={`${classes.root} d-flex d-md-block ${width < parseInt(gridBreakMd) ? "w-100" : "w-10 my-auto"} px-5`}>

                        <ListItem className={`${classes.root} flex-column flex-md-row`}>
                          <ListItemIcon className={`${classes.root} d-inline`} >
                            <FaceOne></FaceOne>
                          </ListItemIcon>
                          <ListItemText primary="0-1" className={classes.root} />
                        </ListItem>

                        <ListItem className={`${classes.root} flex-column flex-md-row`}>
                          <ListItemIcon className={classes.root}>
                            <FaceTwo></FaceTwo>
                          </ListItemIcon>
                          <ListItemText primary="1-3" className={`${classes.root}`} />
                        </ListItem>

                        <ListItem className={`${classes.root} flex-column flex-md-row`}>
                          <ListItemIcon className={classes.root}>
                            <FaceThree></FaceThree>
                          </ListItemIcon>
                          <ListItemText primary="3-5" className={classes.root} />
                        </ListItem>

                        <ListItem className={`${classes.root} flex-column flex-md-row`}>
                          <ListItemIcon className={classes.root}>
                            <FaceFour></FaceFour>
                          </ListItemIcon>
                          <ListItemText primary="5-7" className={classes.root} />
                        </ListItem>

                        <ListItem className={`${classes.root} flex-column flex-md-row`}>
                          <ListItemIcon className={classes.root}>
                            <FaceFive></FaceFive>
                          </ListItemIcon>
                          <ListItemText primary="7-9" className={classes.root} />
                        </ListItem>

                        <ListItem className={`${classes.root} flex-column flex-md-row`}>
                          <ListItemIcon className={classes.root}>
                            <FaceSix></FaceSix>
                          </ListItemIcon>
                          <ListItemText primary="9-10" className={classes.root} />
                        </ListItem>
                      </List>
                    
                      </div>
                    
                    </div>
                  </div>
                </Paper>
              </Col>
              <Col lg={6} xs={12} hidden={!props.userViewWoundsTypeDiagnosis}>
                <Paper className="card-user-clinical-vison my-3 my-md-3 my-lg-4">
                  <Typography variant='h6' className={`pb-3 ${classes.h6}`}>
                    {t('Dashboard.WoundTypesNumberPercentageByDiagnoses')}
                  </Typography>
                  <div className="text-center px-0 px-md-5 px-lg-0">
                    <div className="empty-state-container position-absolute left-0 right-0" hidden={props.WoundsByDiagnosisLabels.length > 0 || props.isLoading}>
                      <Image className={`empty-state-graph pt-4`} fluid alt="empty state" src={noResults}></Image>
                      <Typography variant='subtitle2' className={`pb-3 ${classes.h6}`}>
                        {t('EmptyStates.NoResults')}
                      </Typography>
                    </div>
                    <LoadingModal hidden={!props.isLoading} />
                    <MainChart
                      hidden={props.isLoading || props.WoundsByDiagnosisLabels.length == 0}
                      typeOfChart='bar'
                      chartLabels={props.WoundsByDiagnosisLabels}
                      data={props.WoundsByDiagnosisData}
                      yAxesTicksMin={props.WoundsByDiagnosisMin}
                      yAxesTicksMax={props.WoundsByDiagnosisMax}
                      yAxesStepSize={props.WoundsByDiagnosisSteps}
                      yAxesTicksCallback={(value, position, array) => {
                        if (position === 0) {
                          return value = '';
                        }
                        return value
                      }}
                      /*yAxesTicksCallback={(value, position, array) => {
                          let dataset = (data.datasets || '')[tooltipItem.datasetIndex];
                          let total: number = (dataset.data || '').reduce(function (previousValue: number, currentValue: number) {
                              return previousValue + currentValue;
                          });
                          let currentValue = dataset.data[tooltipItem.index] as number;
                          let precentage = Math.floor(((currentValue / total) * 100) + 0.5);
                          return props.InterventionsDelayedByTypeLabels[tooltipItem.index] + ": " + precentage + "%";
                      }}*/
                      tooltipCallback={{
                        title: function (tooltipItem, data) {
                          if (tooltipItem.length > 0) {
                            return tooltipItem[0].label !== undefined ? tooltipItem[0].label : "";
                          } else {
                            return ""
                          }
                        },
                        label: function (tooltipItem, data) {
                          let label;

                          if (tooltipItem.datasetIndex != undefined && tooltipItem.index != undefined) {
                            /* let dataset = data.datasets || [];

                            let total: number = (dataset.data || '').reduce(function (previousValue: number, currentValue: number) {
                                return previousValue + currentValue;
                            }); */

                            let total = 0;
                            for (let i = 0; i < props.WoundsByDiagnosisData.length; i++) {
                              total = total + props.WoundsByDiagnosisData[i].data[tooltipItem.index];
                            }
                            let percentage = Math.floor(((props.WoundsByDiagnosisData[tooltipItem.datasetIndex].data[tooltipItem.index] / total) * 100) + 0.5)

                            return props.WoundsByDiagnosisData[tooltipItem.datasetIndex].label + ": " + props.WoundsByDiagnosisData[tooltipItem.datasetIndex].data[tooltipItem.index] + " (" + percentage + "%)"
                          } else {
                            label = "";
                          }
                          return label;
                        }
                      }}
                      xStacked={true}
                      yStacked={true}
                    >
                    </MainChart>
                  </div>
                </Paper>
              </Col>
              <Col lg={9} xs={12} hidden={!props.userViewWoundsTypeGender}>
                <Paper className="card-user-clinical-vison my-3 my-md-3 my-lg-4">
                  <Typography variant='h6' className={`pb-3 ${classes.h6}`}>
                    {t('Dashboard.TypesOfWoundsNumberPercentageByGender')}
                  </Typography>
                  <div className="text-center px-0 px-md-5 px-lg-0">
                    <div className="empty-state-container position-absolute left-0 right-0" hidden={props.WoundsByTypeGenderLabels.length > 0 || props.isLoading}>
                      <Image className={`empty-state-graph pt-4`} fluid alt="empty state" src={noResults}></Image>
                      <Typography variant='subtitle2' className={`pb-3 ${classes.h6}`}>
                        {t('EmptyStates.NoResults')}
                      </Typography>
                    </div>
                    <LoadingModal hidden={!props.isLoading} />
                    <MainChart
                      hidden={props.isLoading || props.WoundsByTypeGenderLabels.length == 0}
                      typeOfChart='bar'
                      chartLabels={props.WoundsByTypeGenderLabels}
                      data={[{
                        backgroundColor: '#4FC3F7',
                        borderColor: '#4FC3F7',
                        borderWidth: 1,
                        data: props.WoundsByTypeGenderNumbersMen,
                        hidden: false,
                        label: t("Dashboard.Male"),
                        fontSize: 27
                      }, {
                        backgroundColor: '#F06292',
                        borderColor: '#F06292',
                        borderWidth: 1,
                        data: props.WoundsByTypeGenderNumbersWomen,
                        hidden: false,
                        label: t("Dashboard.Female"),
                        fontSize: 27
                      }]}
                      tooltipCallback={{
                        title: function (tooltipItem, data) {
                          if (tooltipItem.length > 0) {
                            return tooltipItem[0].label !== undefined ? tooltipItem[0].label : "";
                          } else {
                            return ""
                          }
                        },
                        label: function (tooltipItem, data) {
                          let label;
                          if (tooltipItem.datasetIndex === 0) {
                            label = t("Dashboard.Male") + ": " + props.WoundsByTypeGenderNumbersMen[tooltipItem.index as any] + " (" + props.WoundsByTypeGenderPercMen[tooltipItem.index as any] + " %)";
                          } else {
                            label = t("Dashboard.Female") + ": " + props.WoundsByTypeGenderNumbersWomen[tooltipItem.index as any] + " (" + props.WoundsByTypeGenderPercWomen[tooltipItem.index as any] + " %)";
                          }
                          return label;
                        },
                      }}
                      yAxesTicksMin={props.WoundsByTypeGenderMin}
                      yAxesTicksMax={props.WoundsByTypeGenderMax}
                      yAxesStepSize={props.WoundsByTypeGenderSteps}
                      yAxesTicksCallback={(value, position, array) => {
                        if (position === 0) {
                          return value = '';
                        }
                        return value
                      }}

                    >
                    </MainChart>
                  </div>
                </Paper>
              </Col>
              <Col lg={3} md={6} xs={12} hidden={!props.userViewNrDelayedTreatments}>
                <Paper className="card-user-clinical-vison only-numbers my-3 my-md-3 my-lg-4">
                  <Typography variant='h6' className={` ${classes.h6} pb-4 `} >
                    {t('Dashboard.NumberOfDelayedTreatments')}
                  </Typography>
                  <Typography variant='h1' className={` ${classes.h1} pt-5 mt-5 text-center `} hidden={props.isLoading}>
                    {props.NumberOfMonitorDelay}
                  </Typography>
                  <LoadingModal hidden={!props.isLoading} />
                </Paper>
              </Col>
            </Row>
          </BoardAccordion>
        </Container>
      </Dashboard>
    </>
  )
}

export default DashboardPage;
